import { inject, Injectable } from '@angular/core';
import {
  MemorialRowWithSignedUrl,
  SupabaseDatabase,
  SupabaseStorage,
} from '@itavan/lib/core/supabase';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class MemorialsService {
  private db = inject(SupabaseDatabase);
  private storage = inject(SupabaseStorage);
  private logger = inject(LoggerService);
  private readonly THUMBNAIL_MAX_SIZE = 640;
  private readonly IMAGE_EXTENSION = 'webp';

  async getUserMemorials(authUserId: string, options?: { abortSignal?: AbortSignal }) {
    this.logger.log('getUserMemorials for user', authUserId);
    const { abortSignal } = options ?? {};
    // TODO: verificar la seguridad el OJO OJO RLS puede dar acceso a todos los memoriales publicos
    // Con tu regla RLS, esto es seguro y eficiente
    const query = this.db
      .from('memorial')
      .select(
        `
      *,
      avatar:memorial_media!memorial_id(
        id,
        file_name,
        mime_type
      )
    `
      )
      .eq('is_active', true)
      .eq('user_id', authUserId)
      .eq('memorial_media.media_role', 'AVATAR')
      .order('updated_at', { ascending: false });

    if (abortSignal) {
      query.abortSignal(abortSignal);
    }

    const { data, error } = await query;

    if (error) {
      throw error;
    }

    this.logger.log('memorialsData', data);

    const memorialsWithUrls = await Promise.all(
      data.map(async (memorial) => {
        if (memorial.avatar.length == 0) {
          return {
            ...memorial,
            avatar_url: null,
          };
        }

        const avatar = memorial.avatar[0];

        let thumbnailUrl = null;
        const isPublic = memorial.is_public;
        const filePath = `memorial/${memorial.id}/${avatar.file_name}`;

        if (isPublic) {
          thumbnailUrl = this.storage.getPublicUrl(
            'ecoseternos-storage',
            filePath.replace(
              `.${this.IMAGE_EXTENSION}`,
              `_${this.THUMBNAIL_MAX_SIZE}.${this.IMAGE_EXTENSION}`
            )
          );
        } else {
          const { data: thumbnailUrlData, error: thumbnailUrlError } =
            await this.storage.createSignedUrl(
              'ecoseternos-storage',
              filePath.replace(
                `.${this.IMAGE_EXTENSION}`,
                `_${this.THUMBNAIL_MAX_SIZE}.${this.IMAGE_EXTENSION}`
              ),
              3600 // 1 hora de validez
            );
          thumbnailUrl = thumbnailUrlError ? null : thumbnailUrlData.signedUrl;
        }

        return {
          ...memorial,
          avatar: {
            ...avatar,
            signed_url: thumbnailUrl,
          },
        };
      })
    );

    return memorialsWithUrls as MemorialRowWithSignedUrl[];
  }
}
